import {
  ApplicationConfig,
  LOCALE_ID,
  provideZoneChangeDetection,
  APP_INITIALIZER
} from '@angular/core';
import { provideRouter } from '@angular/router';
import { routes } from './app.routes';
import { provideHttpClient, withInterceptorsFromDi, HTTP_INTERCEPTORS } from '@angular/common/http';
import { provideTransloco, TRANSLOCO_MISSING_HANDLER } from '@jsverse/transloco';
import {
  CustomTranslocoMissingHandler,
  TranslocoHttpLoader
} from './services/transloco-loader.service';
import { MAT_DATE_LOCALE, provideNativeDateAdapter } from '@angular/material/core';
import { provideOAuthClient } from 'angular-oauth2-oidc';
import '@angular/common/locales/global/de';
import { ConfigService } from './services/config/config.service';
import { environment } from '@htx/environment';
import { AuthInterceptor } from './services/auth/auth.interceptor';
import { AuthService } from './services/auth/auth.service';
import { ProdAuthService } from './services/auth/prod-auth.service';
import { MockAuthService } from './services/auth/mock-auth.service';
import { RoleService } from './services/role/role.service';
import { ProdRoleService } from './services/role/prod-role.service';
import { MockRoleService } from './services/role/mock-role.service';

function initializeConfig(configService: ConfigService): () => Promise<void> {
  return () => configService.loadConfig();
}

export const appConfig: ApplicationConfig = {
  providers: [
    {
      provide: APP_INITIALIZER,
      useFactory: initializeConfig,
      deps: [ConfigService],
      multi: true
    },
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes),
    provideHttpClient(withInterceptorsFromDi()),
    { provide: LOCALE_ID, useValue: 'de-DE' },
    { provide: MAT_DATE_LOCALE, useValue: 'de-DE' },
    provideNativeDateAdapter(),
    provideTransloco({
      config: {
        availableLangs: ['de', 'en'],
        defaultLang: 'de',
        // Remove this option if your application doesn't support changing language in runtime.
        reRenderOnLangChange: true
      },
      loader: TranslocoHttpLoader
    }),
    { provide: TRANSLOCO_MISSING_HANDLER, useClass: CustomTranslocoMissingHandler },
    provideOAuthClient({
      resourceServer: {
        allowedUrls: [environment.backendUrl],
        sendAccessToken: true
      }
    }),
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthInterceptor,
      multi: true
    },
    {
      provide: AuthService,
      useClass: environment.useMocks ? MockAuthService : ProdAuthService
    },
    {
      provide: RoleService,
      useClass: environment.useMocks ? MockRoleService : ProdRoleService
    }
  ]
};
